// Centralized navigation configuration by role
// Used by both Navbar and WelcomePage

export const getNavigationByRole = (role) => {
  const NAV = {
    EMPLOYEE: [
      {
        title: 'Thông tin cá nhân',
        icon: 'fa-user',
        color: '#15803d',
        items: [
          { to: '/profile', label: 'Thông tin cá nhân', icon: 'fa-user' },
          { to: '/employee-evaluations', label: 'Đánh giá của tôi', icon: 'fa-star' },
          { to: '/performance-management', label: 'Hiệu suất của tôi', icon: 'fa-chart-line' }
        ]
      },
      {
        title: 'Quản lý xe',
        icon: 'fa-car',
        color: '#2f6bd8',
        items: [
          { to: '/request', label: 'Gửi yêu cầu mượn xe', icon: 'fa-car-side' },
          { to: '/approval', label: 'Theo dõi yêu cầu', icon: 'fa-clipboard-check' },
          { to: '/return', label: 'Trả xe', icon: 'fa-undo-alt' }
        ]
      },
      {
        title: 'Hỗ trợ & Công việc',
        icon: 'fa-tasks',
        color: '#d97706',
        items: [
          { to: '/work-journal', label: 'Nhật ký công việc', icon: 'fa-book-alt' },
          { to: '/leave-requests', label: 'Quản lý đơn nghỉ phép', icon: 'fa-calendar-alt' },
          { to: '/driver-schedule', label: 'Lịch tài xế của tôi', icon: 'fa-calendar-check' }
        ]
      },
      {
        title: 'Công cụ & Tiện ích',
        icon: 'fa-toolbox',
        color: '#db2777',
        items: [
          { to: '/pdf-management', label: 'Quản lý PDF', icon: 'fa-file-pdf' }
        ]
      },
      {
        title: 'Thông tin & Hỗ trợ',
        icon: 'fa-headset',
        color: '#8b7bf0',
        items: [
          { to: '/announcements', label: 'Thông báo & Cập nhật', icon: 'fa-bullhorn' },
          { to: '/support', label: 'Gửi yêu cầu hỗ trợ', icon: 'fa-question-circle' },
          { to: '/my-support-requests', label: 'Yêu cầu của tôi', icon: 'fa-ticket-alt' },
          { to: '/guide', label: 'Hướng dẫn sử dụng', icon: 'fa-book' },
          { to: '/company-documents', label: 'Tài liệu công ty', icon: 'fa-file-alt' }
        ]
      }
    ],
    LEVEL_I_MANAGER: [
      {
        title: 'Tổng quan & Cá nhân',
        icon: 'fa-tachometer-alt',
        color: '#15803d',
        items: [
          { to: '/profile', label: 'Thông tin cá nhân', icon: 'fa-user' },
          { to: '/employee-evaluations', label: 'Đánh giá nhân viên', icon: 'fa-star' },
          { to: '/performance-management', label: 'Quản lý hiệu suất', icon: 'fa-chart-line' },
          { to: '/leave-requests', label: 'Quản lý đơn nghỉ phép', icon: 'fa-calendar-alt' }
        ]
      },
      {
        title: 'Quản lý xe & Vận hành',
        icon: 'fa-car',
        color: '#2f6bd8',
        items: [
          { to: '/request', label: 'Gửi yêu cầu mượn xe', icon: 'fa-car-side' },
          { to: '/approval', label: 'Phê duyệt yêu cầu', icon: 'fa-clipboard-check' },
          { to: '/vehicle-management', label: 'Quản lý thông tin xe', icon: 'fa-cogs' },
          { to: '/fuel-management', label: 'Quản lý nhiên liệu', icon: 'fa-gas-pump' },
          { to: '/return', label: 'Trả xe', icon: 'fa-undo-alt' },
          { to: '/return-reports', label: 'Báo cáo trả xe', icon: 'fa-clipboard-list' }
        ]
      },
      {
        title: 'Báo cáo & Thống kê',
        icon: 'fa-chart-line',
        color: '#ef4444',
        items: [
          { to: '/report', label: 'Báo cáo & Thống kê xe', icon: 'fa-chart-bar' },
          { to: '/work-journal', label: 'Quản lý báo cáo công việc', icon: 'fa-book-alt' }
        ]
      },
      {
        title: 'Tuyển dụng nhân sự',
        icon: 'fa-user-plus',
        color: '#8b7bf0',
        items: [
          { to: '/recruitment-dashboard', label: 'Bảng điều khiển tuyển dụng', icon: 'fa-tachometer-alt' },
          { to: '/recruitment-requests', label: 'Yêu cầu tuyển dụng', icon: 'fa-file-alt' },
          { to: '/interviews', label: 'Quản lý phỏng vấn', icon: 'fa-calendar-alt' }
        ]
      },
      {
        title: 'Công cụ & Tiện ích',
        icon: 'fa-toolbox',
        color: '#db2777',
        items: [
          { to: '/pdf-management', label: 'Quản lý PDF', icon: 'fa-file-pdf' }
        ]
      },
      {
        title: 'Thông tin & Hỗ trợ',
        icon: 'fa-headset',
        color: '#4c85e3',
        items: [
          { to: '/announcements', label: 'Thông báo & Cập nhật', icon: 'fa-bullhorn' },
          { to: '/support', label: 'Gửi yêu cầu hỗ trợ', icon: 'fa-question-circle' },
          { to: '/my-support-requests', label: 'Yêu cầu của tôi', icon: 'fa-ticket-alt' },
          { to: '/guide', label: 'Hướng dẫn sử dụng', icon: 'fa-book' },
          { to: '/company-documents', label: 'Tài liệu công ty', icon: 'fa-file-alt' }
        ]
      }
    ],
    LEVEL_II_MANAGER: [
      {
        title: 'Bảng điều khiển điều hành',
        icon: 'fa-tachometer-alt',
        color: '#15803d',
        items: [
          { to: '/profile', label: 'Thông tin cá nhân', icon: 'fa-user' },
          { to: '/leave-requests', label: 'Quản lý đơn nghỉ phép', icon: 'fa-calendar-alt' },
          { to: '/software-rating-management', label: 'Quản lý đánh giá phần mềm', icon: 'fa-star' }
        ]
      },
      {
        title: 'Quản lý đội xe',
        icon: 'fa-car',
        color: '#2f6bd8',
        items: [
          { to: '/request', label: 'Gửi yêu cầu mượn xe', icon: 'fa-car-side' },
          { to: '/approval', label: 'Phê duyệt yêu cầu', icon: 'fa-clipboard-check' },
          { to: '/vehicle-management', label: 'Quản lý thông tin xe', icon: 'fa-cogs' },
          { to: '/fuel-management', label: 'Quản lý nhiên liệu', icon: 'fa-gas-pump' },
          { to: '/return', label: 'Trả xe', icon: 'fa-undo-alt' },
          { to: '/return-reports', label: 'Báo cáo trả xe', icon: 'fa-clipboard-list' }
        ]
      },
      {
        title: 'Quản lý nhân sự',
        icon: 'fa-users',
        color: '#136c34',
        items: [
          { to: '/human-resources', label: 'Quản lý nhân sự công ty', icon: 'fa-user-tie' },
          { to: '/probationary-management', label: 'Quản lý thử việc', icon: 'fa-user-clock' },
          { to: '/driver-profiles', label: 'Hồ sơ tài xế', icon: 'fa-id-card' },
          { to: '/admin/driver-management', label: 'Quản lý hồ sơ tài xế nâng cao', icon: 'fa-users-cog' },
          { to: '/employee-evaluations', label: 'Đánh giá nhân viên', icon: 'fa-star' },
          { to: '/performance-management', label: 'Quản lý hiệu suất', icon: 'fa-chart-line' },
          { to: '/attendance-management', label: 'Quản lý chấm công', icon: 'fa-clock' }
        ]
      },
      {
        title: 'Tuyển dụng nhân sự',
        icon: 'fa-user-plus',
        color: '#8b7bf0',
        items: [
          { to: '/recruitment-dashboard', label: 'Bảng điều khiển tuyển dụng', icon: 'fa-tachometer-alt' },
          { to: '/recruitment-requests', label: 'Yêu cầu tuyển dụng', icon: 'fa-file-alt' },
          { to: '/interviews', label: 'Quản lý phỏng vấn', icon: 'fa-calendar-alt' }
        ]
      },
      {
        title: 'Quản lý hành chính',
        icon: 'fa-building',
        color: '#d97706',
        items: [
          { to: '/reception', label: 'Quản lý thăm gặp & làm việc', icon: 'fa-door-open' },
          { to: '/admin-work-management', label: 'Phạm vi công việc', icon: 'fa-briefcase' },
          { to: '/asset-management', label: 'Quản lý tài sản', icon: 'fa-boxes' },
          { to: '/pickup-schedules', label: 'Lịch đón khách', icon: 'fa-calendar-check' }
        ]
      },
      {
        title: 'Báo cáo & Phân tích',
        icon: 'fa-chart-line',
        color: '#ef4444',
        items: [
          { to: '/report', label: 'Báo cáo & Thống kê xe', icon: 'fa-chart-bar' },
          { to: '/work-journal', label: 'Quản lý báo cáo công việc', icon: 'fa-book-alt' }
        ]
      },
      {
        title: 'Công cụ & Tiện ích',
        icon: 'fa-toolbox',
        color: '#db2777',
        items: [
          { to: '/pdf-management', label: 'Quản lý PDF', icon: 'fa-file-pdf' }
        ]
      },
      {
        title: 'Thông tin & Hỗ trợ',
        icon: 'fa-headset',
        color: '#4c85e3',
        items: [
          { to: '/announcements', label: 'Thông báo & Cập nhật', icon: 'fa-bullhorn' },
          { to: '/support', label: 'Gửi yêu cầu hỗ trợ', icon: 'fa-question-circle' },
          { to: '/my-support-requests', label: 'Yêu cầu của tôi', icon: 'fa-ticket-alt' },
          { to: '/guide', label: 'Hướng dẫn sử dụng', icon: 'fa-book' },
          { to: '/company-documents', label: 'Tài liệu công ty', icon: 'fa-file-alt' },
          { to: '/support-admin', label: 'Quản lý hỗ trợ', icon: 'fa-user-cog' }
        ]
      }
    ],
    ACCOUNTANT: [
      {
        title: 'Thông tin cá nhân',
        icon: 'fa-user',
        color: '#15803d',
        items: [
          { to: '/profile', label: 'Thông tin cá nhân', icon: 'fa-user' },
          { to: '/employee-evaluations', label: 'Đánh giá của tôi', icon: 'fa-star' },
          { to: '/performance-management', label: 'Hiệu suất của tôi', icon: 'fa-chart-line' },
          { to: '/leave-requests', label: 'Quản lý đơn nghỉ phép', icon: 'fa-calendar-alt' }
        ]
      },
      {
        title: 'Quản lý tài sản & xe',
        icon: 'fa-car',
        color: '#2f6bd8',
        items: [
          { to: '/request', label: 'Gửi yêu cầu mượn xe', icon: 'fa-car-side' },
          { to: '/approval', label: 'Quản lý yêu cầu', icon: 'fa-book-alt' },
          { to: '/vehicle-management', label: 'Quản lý thông tin xe', icon: 'fa-cogs' },
          { to: '/asset-management', label: 'Quản lý tài sản', icon: 'fa-boxes' },
          { to: '/return-reports', label: 'Quản lý báo cáo trả xe', icon: 'fa-clipboard-list' },
          { to: '/fuel-management', label: 'Quản lý nhiên liệu', icon: 'fa-gas-pump' },
          { to: '/report', label: 'Báo cáo & Thống kê xe', icon: 'fa-chart-bar' }
        ]
      },
      {
        title: 'Công cụ & Tiện ích',
        icon: 'fa-toolbox',
        color: '#db2777',
        items: [
          { to: '/pdf-management', label: 'Quản lý PDF', icon: 'fa-file-pdf' }
        ]
      },
      {
        title: 'Báo cáo & Hỗ trợ',
        icon: 'fa-headset',
        color: '#ef4444',
        items: [
          { to: '/work-journal', label: 'Quản lý báo cáo công việc', icon: 'fa-book-alt' },
          { to: '/announcements', label: 'Thông báo & Cập nhật', icon: 'fa-bullhorn' },
          { to: '/support', label: 'Gửi yêu cầu hỗ trợ', icon: 'fa-question-circle' },
          { to: '/my-support-requests', label: 'Yêu cầu của tôi', icon: 'fa-ticket-alt' },
          { to: '/guide', label: 'Hướng dẫn sử dụng', icon: 'fa-book' },
          { to: '/company-documents', label: 'Tài liệu công ty', icon: 'fa-file-alt' }
        ]
      }
    ],
    REPORT_MANAGER: [
      {
        title: 'Thông tin cá nhân',
        icon: 'fa-user',
        color: '#15803d',
        items: [
          { to: '/profile', label: 'Thông tin cá nhân', icon: 'fa-user' },
          { to: '/employee-evaluations', label: 'Đánh giá của tôi', icon: 'fa-star' },
          { to: '/performance-management', label: 'Hiệu suất của tôi', icon: 'fa-chart-line' },
          { to: '/leave-requests', label: 'Quản lý đơn nghỉ phép', icon: 'fa-calendar-alt' }
        ]
      },
      {
        title: 'Quản lý xe',
        icon: 'fa-car',
        color: '#2f6bd8',
        items: [
          { to: '/vehicle-management', label: 'Quản lý thông tin xe', icon: 'fa-cogs' },
          { to: '/report', label: 'Báo cáo & Thống kê xe', icon: 'fa-chart-bar' },
          { to: '/request', label: 'Gửi yêu cầu mượn xe', icon: 'fa-car-side' },
          { to: '/approval', label: 'Quản lý yêu cầu', icon: 'fa-clipboard-check' },
          { to: '/return', label: 'Trả xe', icon: 'fa-undo-alt' }
        ]
      },
      {
        title: 'Quản lý Nhân sự',
        icon: 'fa-users',
        color: '#136c34',
        items: [
          { to: '/probationary-management', label: 'Quản lý thử việc', icon: 'fa-user-clock' }
        ]
      },
      {
        title: 'Báo cáo công việc',
        icon: 'fa-book-alt',
        color: '#ef4444',
        items: [
          { to: '/work-journal', label: 'Quản lý báo cáo công việc', icon: 'fa-book-alt' }
        ]
      },
      {
        title: 'Tuyển dụng phòng ban',
        icon: 'fa-user-plus',
        color: '#8b7bf0',
        items: [
          { to: '/recruitment-dashboard', label: 'Bảng điều khiển tuyển dụng', icon: 'fa-tachometer-alt' },
          { to: '/recruitment-requests', label: 'Yêu cầu tuyển dụng', icon: 'fa-file-alt' },
          { to: '/interviews', label: 'Phỏng vấn phòng ban', icon: 'fa-calendar-alt' }
        ]
      },
      {
        title: 'Công cụ & Tiện ích',
        icon: 'fa-toolbox',
        color: '#db2777',
        items: [
          { to: '/pdf-management', label: 'Quản lý PDF', icon: 'fa-file-pdf' }
        ]
      },
      {
        title: 'Thông tin & Hỗ trợ',
        icon: 'fa-headset',
        color: '#4c85e3',
        items: [
          { to: '/announcements', label: 'Thông báo & Cập nhật', icon: 'fa-bullhorn' },
          { to: '/support', label: 'Gửi yêu cầu hỗ trợ', icon: 'fa-question-circle' },
          { to: '/my-support-requests', label: 'Yêu cầu của tôi', icon: 'fa-ticket-alt' },
          { to: '/guide', label: 'Hướng dẫn sử dụng', icon: 'fa-book' },
          { to: '/company-documents', label: 'Tài liệu công ty', icon: 'fa-file-alt' }
        ]
      }
    ],
    ADMIN: [
      {
        title: 'Bảng điều khiển quản trị',
        icon: 'fa-tachometer-alt',
        color: '#15803d',
        items: [
          { to: '/executive-dashboard', label: 'Tổng quan doanh nghiệp', icon: 'fa-chart-bar' },
          { to: '/profile', label: 'Thông tin cá nhân', icon: 'fa-user' },
          { to: '/employee-evaluations', label: 'Đánh giá nhân viên', icon: 'fa-star' },
          { to: '/performance-management', label: 'Quản lý hiệu suất', icon: 'fa-chart-line' },
          { to: '/leave-requests', label: 'Quản lý đơn nghỉ phép', icon: 'fa-calendar-alt' },
          { to: '/software-rating-management', label: 'Quản lý đánh giá phần mềm', icon: 'fa-star-half-alt' }
        ]
      },
      {
        title: 'Vận hành đội xe',
        icon: 'fa-car',
        color: '#2f6bd8',
        items: [
          { to: '/request', label: 'Gửi yêu cầu mượn xe', icon: 'fa-car-side' },
          { to: '/approval', label: 'Phê duyệt yêu cầu', icon: 'fa-clipboard-check' },
          { to: '/vehicle-management', label: 'Quản lý thông tin xe', icon: 'fa-cogs' },
          { to: '/vehicle-qr-management', label: 'QR Code quản lý xe', icon: 'fa-qrcode' },
          { to: '/fuel-management', label: 'Quản lý nhiên liệu', icon: 'fa-gas-pump' },
          { to: '/return', label: 'Trả xe', icon: 'fa-undo-alt' },
          { to: '/return-reports', label: 'Báo cáo trả xe', icon: 'fa-clipboard-list' }
        ]
      },
      {
        title: 'Quản lý nhân sự',
        icon: 'fa-users',
        color: '#136c34',
        items: [
          { to: '/human-resources', label: 'Quản lý nhân sự công ty', icon: 'fa-user-tie' },
          { to: '/probationary-management', label: 'Quản lý thử việc', icon: 'fa-user-clock' },
          { to: '/driver-profiles', label: 'Hồ sơ tài xế', icon: 'fa-id-card' },
          { to: '/admin/driver-management', label: 'Quản lý hồ sơ tài xế nâng cao', icon: 'fa-users-cog' },
          { to: '/work-journal', label: 'Quản lý báo cáo công việc', icon: 'fa-book-alt' },
          { to: '/attendance-management', label: 'Quản lý chấm công', icon: 'fa-clock' }
        ]
      },
      {
        title: 'Tuyển dụng nhân sự',
        icon: 'fa-user-plus',
        color: '#8b7bf0',
        items: [
          { to: '/recruitment-dashboard', label: 'Bảng điều khiển tuyển dụng', icon: 'fa-tachometer-alt' },
          { to: '/recruitment-requests', label: 'Yêu cầu tuyển dụng', icon: 'fa-file-alt' },
          { to: '/interviews', label: 'Quản lý phỏng vấn', icon: 'fa-calendar-alt' }
        ]
      },
      {
        title: 'Quản lý tài sản & cơ sở',
        icon: 'fa-building',
        color: '#d97706',
        items: [
          { to: '/asset-management', label: 'Quản lý tài sản', icon: 'fa-boxes' },
          { to: '/reception', label: 'Quản lý thăm gặp & làm việc', icon: 'fa-door-open' },
          { to: '/admin-work-management', label: 'Phạm vi công việc', icon: 'fa-briefcase' },
          { to: '/pickup-schedules', label: 'Lịch đón khách', icon: 'fa-calendar-check' }
        ]
      },
      {
        title: 'Báo cáo & Phân tích',
        icon: 'fa-chart-line',
        color: '#ef4444',
        items: [
          { to: '/report', label: 'Báo cáo & Thống kê xe', icon: 'fa-chart-bar' },
          { to: '/work-journal', label: 'Quản lý báo cáo công việc', icon: 'fa-book-alt' }
        ]
      },
      {
        title: 'Công cụ & Tiện ích',
        icon: 'fa-toolbox',
        color: '#db2777',
        items: [
          { to: '/pdf-management', label: 'Quản lý PDF', icon: 'fa-file-pdf' }
        ]
      },
      {
        title: 'Thông tin & Hỗ trợ',
        icon: 'fa-headset',
        color: '#4c85e3',
        items: [
          { to: '/announcements', label: 'Thông báo & Cập nhật', icon: 'fa-bullhorn' },
          { to: '/support', label: 'Gửi yêu cầu hỗ trợ', icon: 'fa-question-circle' },
          { to: '/my-support-requests', label: 'Yêu cầu của tôi', icon: 'fa-ticket-alt' },
          { to: '/guide', label: 'Hướng dẫn sử dụng', icon: 'fa-book' },
          { to: '/company-documents', label: 'Tài liệu công ty', icon: 'fa-file-alt' },
          { to: '/support-admin', label: 'Quản lý hỗ trợ', icon: 'fa-user-cog' }
        ]
      }
    ],
    SUPER_ADMIN: [
      {
        title: 'Bảng điều khiển tổng quản trị',
        icon: 'fa-crown',
        color: '#dc2626',
        items: [
          { to: '/executive-dashboard', label: 'Tổng quan doanh nghiệp', icon: 'fa-chart-bar' },
          { to: '/profile', label: 'Thông tin cá nhân', icon: 'fa-user' },
          { to: '/leave-requests', label: 'Quản lý đơn nghỉ phép', icon: 'fa-calendar-alt' }
        ]
      },
      {
        title: 'Quản trị hệ thống',
        icon: 'fa-cogs',
        color: '#dc2626',
        items: [
          { to: '/superadmin', label: 'Quản lý tài khoản nhân viên', icon: 'fa-user-shield' },
          { to: '/activity-logs', label: 'Nhật ký hoạt động', icon: 'fa-history' },
          { to: '/admin/announcements', label: 'Quản lý thông báo', icon: 'fa-bell' },
          { to: '/admin-notifications', label: 'Quản lý thông báo cũ', icon: 'fa-bell' },
          { to: '/link-management', label: 'Quản lý liên kết', icon: 'fa-link' },
          { to: '/page-visibility', label: 'Quản lý hiển thị trang', icon: 'fa-eye' },
          { to: '/system-status', label: 'Quản lý trạng thái hệ thống', icon: 'fa-server' },
          { to: '/health-check', label: 'Health Check Dashboard', icon: 'fa-heartbeat' },
          { to: '/audit-trail', label: 'Audit Trail (CRUD Log)', icon: 'fa-shield-alt' },
          { to: '/cron-dashboard', label: 'Quản lý Cron Jobs', icon: 'fa-clock' },
          { to: '/backup-manager', label: 'Quản lý Backup', icon: 'fa-database' },
          { to: '/online-users', label: 'Theo dõi người dùng trực tuyến', icon: 'fa-users' },
          { to: '/software-rating-management', label: 'Quản lý đánh giá phần mềm', icon: 'fa-star-half-alt' }
        ]
      },
      {
        title: 'Quản lý đội xe & tài sản',
        icon: 'fa-car',
        color: '#2f6bd8',
        items: [
          { to: '/request', label: 'Gửi yêu cầu mượn xe', icon: 'fa-car-side' },
          { to: '/approval', label: 'Phê duyệt yêu cầu', icon: 'fa-clipboard-check' },
          { to: '/vehicle-management', label: 'Quản lý thông tin xe', icon: 'fa-cogs' },
          { to: '/vehicle-qr-management', label: 'QR Code quản lý xe', icon: 'fa-qrcode' },
          { to: '/fuel-management', label: 'Quản lý nhiên liệu', icon: 'fa-gas-pump' },
          { to: '/return', label: 'Trả xe', icon: 'fa-undo-alt' },
          { to: '/return-reports', label: 'Báo cáo trả xe', icon: 'fa-clipboard-list' },
          { to: '/asset-management', label: 'Quản lý tài sản', icon: 'fa-boxes' }
        ]
      },
      {
        title: 'Quản lý nhân sự toàn diện',
        icon: 'fa-users',
        color: '#15803d',
        items: [
          { to: '/human-resources', label: 'Quản lý nhân sự công ty', icon: 'fa-user-tie' },
          { to: '/probationary-management', label: 'Quản lý thử việc', icon: 'fa-user-clock' },
          { to: '/driver-profiles', label: 'Hồ sơ tài xế', icon: 'fa-id-card' },
          { to: '/admin/driver-management', label: 'Quản lý hồ sơ tài xế nâng cao', icon: 'fa-users-cog' },
          { to: '/employee-evaluations', label: 'Đánh giá nhân viên', icon: 'fa-star' },
          { to: '/performance-management', label: 'Quản lý hiệu suất', icon: 'fa-chart-line' },
          { to: '/attendance-management', label: 'Quản lý chấm công', icon: 'fa-clock' }
        ]
      },
      {
        title: 'Tuyển dụng & phát triển',
        icon: 'fa-user-plus',
        color: '#8b7bf0',
        items: [
          { to: '/recruitment-dashboard', label: 'Bảng điều khiển tuyển dụng', icon: 'fa-tachometer-alt' },
          { to: '/recruitment-requests', label: 'Yêu cầu tuyển dụng', icon: 'fa-file-alt' },
          { to: '/interviews', label: 'Quản lý phỏng vấn', icon: 'fa-calendar-alt' }
        ]
      },
      {
        title: 'Quản lý hành chính & cơ sở',
        icon: 'fa-building',
        color: '#d97706',
        items: [
          { to: '/reception', label: 'Quản lý thăm gặp & làm việc', icon: 'fa-door-open' },
          { to: '/admin-work-management', label: 'Phạm vi công việc', icon: 'fa-briefcase' },
          { to: '/pickup-schedules', label: 'Lịch đón khách', icon: 'fa-calendar-check' }
        ]
      },
      {
        title: 'Báo cáo & phân tích toàn diện',
        icon: 'fa-chart-line',
        color: '#ef4444',
        items: [
          { to: '/report', label: 'Báo cáo & Thống kê xe', icon: 'fa-chart-bar' },
          { to: '/work-journal', label: 'Quản lý báo cáo công việc', icon: 'fa-book-alt' }
        ]
      },
      {
        title: 'Công cụ & Tiện ích',
        icon: 'fa-toolbox',
        color: '#db2777',
        items: [
          { to: '/pdf-management', label: 'Quản lý PDF', icon: 'fa-file-pdf' }
        ]
      },
      {
        title: 'Thông tin & hỗ trợ',
        icon: 'fa-headset',
        color: '#4c85e3',
        items: [
          { to: '/announcements', label: 'Thông báo & Cập nhật', icon: 'fa-bullhorn' },
          { to: '/support', label: 'Gửi yêu cầu hỗ trợ', icon: 'fa-question-circle' },
          { to: '/my-support-requests', label: 'Yêu cầu của tôi', icon: 'fa-ticket-alt' },
          { to: '/guide', label: 'Hướng dẫn sử dụng', icon: 'fa-book' },
          { to: '/company-documents', label: 'Tài liệu công ty', icon: 'fa-file-alt' },
          { to: '/support-admin', label: 'Quản lý hỗ trợ', icon: 'fa-user-cog' }
        ]
      }
    ]
  };

  return NAV[role] || [];
};

// Helper to build WelcomePage categories from navigation data
export const buildCategoriesFromNavigation = (role) => {
  const groups = getNavigationByRole(role);
  const toSlug = (text) =>
    String(text || '')
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[^a-z0-9\s-]/g, '')
      .trim()
      .replace(/\s+/g, '-');

  const withFas = (icon) => (icon ? `fas ${icon}` : 'fas fa-circle');

  return groups.map((group) => ({
    id: toSlug(group.title),
    title: group.title,
    icon: withFas(group.icon),
    items: (group.items || []).map((item) => ({
      path: item.to,
      icon: withFas(item.icon),
      title: item.label,
      description: item.description || item.label,
    })),
  }));
};


